import { useEffect } from "react";

export const useUnload = (message) => {
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!message) return;
      e.preventDefault();
      e.returnValue = message; // Safari uses this
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [message]);
};

export default useUnload;
